import { createContext as h, useContext as y, useState as g, useEffect as m, createElement as l, useMemo as x, useCallback as C } from "react";
import { defaultSession as E, $init as k, $get as I } from "@interactivevision/visitor";
const f = h({
  session: E,
  query: {},
  location: "",
  shared: {}
});
f.displayName = "VisitorContext";
function L() {
  return y(f).query;
}
function b() {
  return y(f).location;
}
function T() {
  return y(f).session;
}
function $() {
  return y(f).shared;
}
function O({ finder: t, component: r, ...e }) {
  const [o, u] = g({ component: r, ...e });
  return m(() => {
    k({ state: e, finder: t, update: (i) => u(i) });
  }, []), l(P, o);
}
function P({ component: t, location: r, props: e, session: o, query: u, shared: i }) {
  let s = `visitor-page-${r.replace(/[^a-z0-9]/ig, "-")}`, c = { session: o, shared: i, query: u, location: r }, n;
  return t.layout ? n = l(t.layout, i, l(t, { key: s, ...e })) : n = l(t, { key: s, ...e }), l(f.Provider, { value: c }, n);
}
async function B({ initial: t, resolve: r, render: e, setup: o }) {
  const u = typeof window > "u", { globals: i, ...a } = t || V();
  if (!a || !i)
    throw new Error("No initial page data was found! Make sure you have used required directives within your Blade root view.");
  Object.keys(i).forEach((n) => {
    globalThis[n] = i[n];
  });
  const s = (n) => Promise.resolve(r(n)).then((d) => d.default || d), c = await s(a.view).then((n) => o({ router: O, props: { finder: s, component: n, ...a } }));
  if (!u)
    return "";
  if (e)
    return e(c);
  throw new Error('You must provide "render" function in in SSR context! Use "renderToString" function from "react-dom/server" package.');
}
function V() {
  var t;
  return JSON.parse(((t = document.getElementById("__VISITOR__")) == null ? void 0 : t.textContent) || "");
}
function M({ href: t, target: r, className: e, children: o, end: u, onClick: i, ...a }) {
  const s = b(), [c, n] = g(!1), d = x(() => {
    if (!t)
      return !1;
    let p = s === t, S = !u && s.startsWith(t);
    return p || S;
  }, [s, t, u]), v = C((p) => {
    i && i(p), t && _(p, t, r) && (p.preventDefault(), n(!0), I(t).then(() => n(!1)));
  }, [t, r]), w = {
    href: t,
    target: r,
    className: typeof e == "function" ? e({ isActive: d, isPending: c }) : e,
    onClick: v,
    ...a
  };
  return typeof o == "function" ? o({ isActive: d, isPending: c, ...w }) : l("a", w, o);
}
function _(t, r, e) {
  return e === "_blank" || K(r) ? !1 : !(t.defaultPrevented || t.button > 1 || t.altKey || t.ctrlKey || t.metaKey || t.shiftKey);
}
function K(t) {
  try {
    let r = window.location.host, e = new URL(t).host;
    return r !== e;
  } catch {
    return !1;
  }
}
export {
  M as Link,
  O as Router,
  f as VisitorContext,
  B as createVisitor,
  b as useLocation,
  L as useQuery,
  T as useSession,
  $ as useShared
};
